module.exports = __webpack_public_path__ + "static/usefuldata-af2de7ccc563ac28fbb956d674253aee.png";